import { format as d3Format } from 'd3-format'

export const format = d3Format('($,.2f')
export default format



// WEBPACK FOOTER //
// ./deps/internal-components/src/util/Currency.js